<nav class="navbar navbar-light">
    <div class="main">
        <div class="navbar-header cursor navbarHeader" (click)="navigateToWebsite()">
            <img src="/assets/images/logo.png" alt="logo" class="img-responsive" style="height: 70px; width: 240px;" />
        </div>
    </div>
</nav>
<div class="align-centre">
    <div class="main-header" style="margin-left: 30px;">Hub Delivery Form</div>
    <mat-horizontal-stepper [linear]="isLinear" #stepper>
        <mat-step [stepControl]="firstFormGroup">
            <div class="header-mobile">
                <div class="header-mob">
                    <div class="circle">1</div>
                    <div class="line"></div>
                </div>
                <p class="align-center">Personal & Store Information</p>
            </div>
            <form [formGroup]="firstFormGroup">
                <ng-template matStepperIcon="edit" let-index="index">
                    {{ index + 1 }}
                </ng-template>
                <ng-template class="matsteplael" matStepLabel>Personal Information</ng-template>
                <div class="formContent">
                    <div class="section1">
                        <div class="imageSection">
                            <div class="heading">Personal Information:</div>
                            <div class="content">
                                Providing a up-to date contact details is a great step towards
                                becoming a Hub Delivery delivering partner
                            </div>
                            <div class="imageContent mt-26">
                                <!-- <img src="/assets/images/contact.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="188.813" class="first" height="179.361"
                                    viewBox="0 0 188.813 179.361">
                                    <defs>
                                        <style>
                                            .first cls-1 {
                                                fill: #232f3e;
                                            }
                                        </style>
                                    </defs>
                                    <g id="contact" transform="translate(-.001 -12.813)">
                                        <g id="Group_1602" transform="translate(.001 12.813)">
                                            <g id="Group_1601">
                                                <path id="Path_1184"
                                                    d="M180.787 12.813H48.9a8.036 8.036 0 0 0-8.027 8.027v36.377l-6.031-9.046a9.326 9.326 0 0 0-12.591-2.833L9.845 52.8a18.2 18.2 0 0 0-8.316 10.785C-3 80.066.361 108.461 42.039 150.146c33.145 33.11 57.857 42.028 74.889 42.028a43.974 43.974 0 0 0 11.678-1.523 18.237 18.237 0 0 0 10.79-8.307l7.45-12.421a9.327 9.327 0 0 0-2.833-12.575L114.3 137.542a9.377 9.377 0 0 0-12.553 2.037L93.1 150.7a3.012 3.012 0 0 1-3.853.815l-1.646-.907c-5.417-2.952-12.159-6.629-25.776-20.246-1.473-1.473-2.808-2.852-4.06-4.171h123.022a8.02 8.02 0 0 0 8.027-7.989V20.84a8.036 8.036 0 0 0-8.027-8.027zm-96.2 143.323l1.6.878a9.273 9.273 0 0 0 11.882-2.449l8.65-11.121a3.059 3.059 0 0 1 4.092-.664l29.711 19.805a3.04 3.04 0 0 1 .922 4.092l-7.45 12.421a11.96 11.96 0 0 1-7.054 5.477c-14.879 4.092-40.919.63-80.442-38.9S3.527 80.116 7.609 65.25a11.961 11.961 0 0 1 5.474-7.05L25.5 50.742a3.044 3.044 0 0 1 4.092.922L49.41 81.375a3.056 3.056 0 0 1-.664 4.092L37.622 94.12A9.27 9.27 0 0 0 35.173 106l.881 1.6c3.148 5.773 7.06 12.956 21.322 27.215s21.443 18.173 27.212 21.321zm97.93-37.933a1.718 1.718 0 0 1-1.731 1.7h-128.7a79.381 79.381 0 0 1-10.5-15.31l-.907-1.653a3 3 0 0 1 .812-3.847l11.124-8.653a9.374 9.374 0 0 0 2.037-12.553l-7.483-11.224V20.84a1.712 1.712 0 0 1 1.731-1.732h131.887a1.712 1.712 0 0 1 1.731 1.731V118.2z"
                                                    class="cls-1" transform="translate(-.001 -12.813)" />
                                                <path id="Path_1185"
                                                    d="M263.552 51.228l-52.607 39.9a4.246 4.246 0 0 1-4.992 0l-52.587-39.9a3.149 3.149 0 0 0-3.805 5.017l52.594 39.893a10.594 10.594 0 0 0 12.591 0l52.61-39.893a3.148 3.148 0 0 0-3.8-5.017z"
                                                    class="cls-1" transform="translate(-93.606 -36.654)" />
                                                <path id="Path_1186"
                                                    d="M181.9 173.29l-32.244 34.53a3.148 3.148 0 0 0 4.6 4.294l32.245-34.545a3.148 3.148 0 0 0-4.605-4.278z"
                                                    class="cls-1" transform="translate(-93.919 -113.541)" />
                                                <path id="Path_1187"
                                                    d="M375.4 173.08a3.148 3.148 0 1 0-4.6 4.294l32.235 34.53a3.148 3.148 0 0 0 4.6-4.294z"
                                                    class="cls-1" transform="translate(-233.489 -113.331)" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div class="inputSection">
                                <label class="lableStyle">Name of applicant *</label>
                                <mat-form-field>
                                    <input matInput formControlName="name" [validateInput]="{ alphabets: true }"
                                        required />
                                    <mat-error *ngIf="
                      firstFormGroup.get('name').errors &&
                      (firstFormGroup.get('name').dirty ||
                        firstFormGroup.get('name').touched)
                    ">
                                        <mat-hint [hidden]="!firstFormGroup.get('name').errors.required">Applicant Name
                                            is required
                                        </mat-hint>
                                        <mat-hint [hidden]="!firstFormGroup.get('name').errors.pattern">Name must be
                                            charecter
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label class="lableStyle">Email id (Registered with amazon) *</label>
                                <mat-form-field>
                                    <input matInput formControlName="email_id" required class="newclass" />
                                    <mat-error *ngIf="
                      firstFormGroup.get('email_id').errors &&
                      (firstFormGroup.get('email_id').dirty ||
                        firstFormGroup.get('email_id').touched)
                    ">
                                        <mat-hint [hidden]="!firstFormGroup.get('email_id').errors.required">Email ID is
                                            required
                                        </mat-hint>
                                        <mat-hint [hidden]="!firstFormGroup.get('email_id').errors.pattern">Invalid
                                            Email ID
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label class="lableStyle">Phone Number (10 digit mobile number with out any prefix)
                                    *</label>
                                <mat-form-field class="example-full-width">
                                    <input matInput minlength="10" maxlength="10" formControlName="phone"
                                        [validateInput]="{ 'only-numbers': true }" required />
                                    <mat-error *ngIf="
                      firstFormGroup.get('phone').errors &&
                      (firstFormGroup.get('phone').dirty ||
                        firstFormGroup.get('phone').touched)
                    ">
                                        <mat-hint [hidden]="!firstFormGroup.get('phone').errors.pattern">Phone must be
                                            number
                                        </mat-hint>
                                        <mat-hint [hidden]="!firstFormGroup.get('phone').errors.minlength">Please enter
                                            10 digit phone number
                                        </mat-hint>
                                        <mat-hint [hidden]="!firstFormGroup.get('phone').errors.required">Phone number
                                            is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div></div>
                            <div class="inputSection">
                                <label class="lableStyle">Applicant Address *</label>
                                <mat-form-field class="example-full-width">
                                    <input matInput formControlName="residental_address" required />
                                    <mat-error *ngIf="
                      firstFormGroup.get('residental_address').errors &&
                      (firstFormGroup.get('residental_address').dirty ||
                        firstFormGroup.get('residental_address').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('residental_address').errors
                          .required
                      ">
                                            Applicant Address is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="lineContent"></div>
                    <div class="section2">
                        <div class="imageSection">
                            <div class="heading">Store Information:</div>
                            <div class="content">
                                An up-to-date store information will help to highlight the
                                location and profile of the store.
                            </div>
                            <div class="imageContent2 mt-26">
                                <!-- <img src="/assets/images/store.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" class="first" width="205.326" height="166.75"
                                    viewBox="0 0 205.326 166.75">
                                    <defs>
                                        <style>
                                            .first cls-1 {
                                                fill: #232f3e;
                                            }
                                        </style>
                                    </defs>
                                    <g id="Group_1600" transform="translate(-203.207 -3082.502)">
                                        <g id="shop" transform="translate(203.207 3082.502)">
                                            <g id="Group_1580">
                                                <g id="Group_1579">
                                                    <path id="Path_1182"
                                                        d="M195.889 208.83h-3.422V119.6a27.917 27.917 0 0 0 12.859-23.491 3.01 3.01 0 0 0-.4-1.492l-23.863-41.766a9.459 9.459 0 0 0-8.194-4.755H32.456a9.458 9.458 0 0 0-8.194 4.755L.4 94.617a3.011 3.011 0 0 0-.4 1.492A27.917 27.917 0 0 0 12.859 119.6v89.23H9.437a3.008 3.008 0 0 0 0 6.015h186.452a3.008 3.008 0 0 0 0-6.015zM6.223 99.117h9.642a3.008 3.008 0 1 0 0-6.015H8.191l21.295-37.267a3.429 3.429 0 0 1 2.971-1.724h140.412a3.429 3.429 0 0 1 2.971 1.724L197.135 93.1h-7.676a3.008 3.008 0 1 0 0 6.015h9.641a21.9 21.9 0 0 1-43.393 0H176.6a3.008 3.008 0 1 0 0-6.015H28.726a3.008 3.008 0 1 0 0 6.015h20.89a21.9 21.9 0 0 1-43.393 0zm143.048 0a21.9 21.9 0 0 1-43.389 0zm-49.828 0a21.9 21.9 0 0 1-43.389 0zm70.934 109.714h-32.56v-10.058h32.561zm0-16.074h-32.56v-55.064h32.561zm16.074 16.074h-10.057v-74.145a3.008 3.008 0 0 0-3.008-3.008H134.81a3.008 3.008 0 0 0-3.008 3.008v74.144H18.874v-86.312a27.893 27.893 0 0 0 33.961-13.809 27.916 27.916 0 0 0 49.828 0 27.916 27.916 0 0 0 49.828 0 27.894 27.894 0 0 0 33.961 13.809z"
                                                        class="cls-1" transform="translate(0 -48.096)" />
                                                </g>
                                            </g>
                                            <g id="Group_1582" transform="translate(28.932 83.582)">
                                                <g id="Group_1581">
                                                    <path id="Path_1183"
                                                        d="M161.949 256.516h-86.8a3.008 3.008 0 0 0-3.008 3.008V320.6a3.008 3.008 0 0 0 3.008 3.008h86.8a3.007 3.007 0 0 0 3.008-3.008v-61.076a3.007 3.007 0 0 0-3.008-3.008zm-3.007 61.084H78.16v-55.069h80.781z"
                                                        class="cls-1" transform="translate(-72.145 -256.516)" />
                                                </g>
                                            </g>
                                        </g>
                                        <g id="Rectangle_1775" fill="none" stroke="#0096d6" stroke-width="6px"
                                            transform="translate(232.207 3166.252)">
                                            <rect width="93" height="67" stroke="none" rx="3" />
                                            <path d="M3 3H90V64H3z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div class="inputSection">
                                <label class="lableStyle">Name Of The Store *</label>
                                <mat-form-field co class="example-full-width">
                                    <input matInput formControlName="store_name" [validateInput]="{ alphabets: true }"
                                        required />
                                    <mat-error *ngIf="
                      firstFormGroup.get('store_name').errors &&
                      (firstFormGroup.get('store_name').dirty ||
                        firstFormGroup.get('store_name').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('store_name').errors.required
                      ">Store Name is required
                                        </mat-hint>
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('store_name').errors.pattern
                      ">Store Name must be charecter
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label class="lableStyle">Store Address *</label>
                                <mat-form-field class="example-full-width">
                                    <input matInput formControlName="store_address" required />
                                    <mat-error *ngIf="
                      firstFormGroup.get('store_address').errors &&
                      (firstFormGroup.get('store_address').dirty ||
                        firstFormGroup.get('store_address').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('store_address').errors.required
                      ">Store Address is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label class="lableStyle">Primary Business *</label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="primary_business" placeholder="Select">
                                        <mat-option *ngFor="let primarybusiness of primaryBusinessList"
                                            [value]="primarybusiness.id">
                                            {{ primarybusiness.primary_business }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="
                      firstFormGroup.get('primary_business').errors &&
                      (firstFormGroup.get('primary_business').dirty ||
                        firstFormGroup.get('primary_business').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('primary_business').errors.required
                      ">
                                            Primary Business is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection" [hidden]="firstFormGroup.value.primary_business != 13">
                                <label class="lableStyle">In case of 'Others' please mention "Type Of Business"
                                    *</label>
                                <mat-form-field class="example-full-width">
                                    <input matInput formControlName="other_business"
                                        [required]="firstFormGroup.value.primary_business == 13" />
                                    <mat-error *ngIf="
                      firstFormGroup.get('other_business').errors &&
                      (firstFormGroup.get('other_business').dirty ||
                        firstFormGroup.get('other_business').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('other_business').errors.required
                      ">
                                            Other Business is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label>Pincode *</label>
                                <mat-form-field class="example-full-width">
                                    <input matInput formControlName="pincode" [validateInput]="{ 'only-numbers': true }"
                                        maxlength="6" />
                                    <mat-error *ngIf="
                      firstFormGroup.get('pincode').errors &&
                      (firstFormGroup.get('pincode').dirty ||
                        firstFormGroup.get('pincode').touched)
                    ">
                                        <mat-hint [hidden]="!firstFormGroup.get('pincode').errors.required">Pincode is
                                            required
                                        </mat-hint>
                                        <mat-hint [hidden]="!firstFormGroup.get('pincode').errors.pattern">Pincode must
                                            be number
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label class="lableStyle">Store Location *</label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="location" placeholder="Select">
                                        <mat-option *ngFor="let storeLocation of storeLocations"
                                            [value]="storeLocation.id">
                                            {{ storeLocation.location }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="
                      firstFormGroup.get('location').errors &&
                      (firstFormGroup.get('location').dirty ||
                        firstFormGroup.get('location').touched)
                    ">
                                        <mat-hint [hidden]="!firstFormGroup.get('location').errors.required">
                                            Store Location is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection" [hidden]="firstFormGroup.value.location != 13">
                                <label class="lableStyle">In case of 'Others' please mention "The Location" *</label>
                                <mat-form-field class="example-full-width">
                                    <input matInput formControlName="other_location"
                                        [required]="firstFormGroup.value.location == 13" />
                                    <mat-error *ngIf="
                      firstFormGroup.get('other_location').errors &&
                      (firstFormGroup.get('other_location').dirty ||
                        firstFormGroup.get('other_location').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('other_location').errors.required
                      ">
                                            Other Location is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="inputSection">
                                <label class="lableStyle">Store Monthly Turnover ? *</label>
                                <mat-form-field appearance="fill">
                                    <!-- <mat-label>Select</mat-label> -->
                                    <mat-select formControlName="monthly_turnover" (selectionChange)="check()"
                                        placeholder="Select">
                                        <mat-option *ngFor="let document of monthly_turnover"
                                            [value]="document.turnover">
                                            {{ document.turnover }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="
                      firstFormGroup.get('monthly_turnover').errors &&
                      (firstFormGroup.get('monthly_turnover').dirty ||
                        firstFormGroup.get('monthly_turnover').touched)
                    ">
                                        <mat-hint [hidden]="
                        !firstFormGroup.get('monthly_turnover').errors.required
                      ">
                                            Monthly Turnover is required
                                        </mat-hint>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="align-middle mt-15">
                                <p class="error-msg" *ngIf="!firstFormGroup.valid">
                                    Please fill the required fields
                                </p>
                                <!-- <button class="next-button-1" mat-button matStepperNext [disabled]="!firstFormGroup.valid">Next</button> -->
                                <button class="next-button-1" mat-button matStepperNext>
                                    Next
                                </button>
                                <button mat-button matStepperNext class="back-button">
                                    &gt;&gt;
                                </button>
                            </div>
                            <!-- <div class="submitButton">
                                <button class="next-button submitPill" mat-button matStepperNext
                                    [disabled]="!firstFormGroup.valid">Next</button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup">
            <div class="header-mobile">
                <div class="header2-mob">
                    <div class="line"></div>
                    <div class="circle">2</div>
                    <div class="line"></div>
                </div>
                <p class="align-center">Identification</p>
            </div>
            <form [formGroup]="secondFormGroup">
                <ng-template class="matsteplael" matStepLabel>Identification</ng-template>
                <div class="formContent">
                    <div class="quetionTag">
                        In case you want to partner with amazon as an Hub Delivery Store, certain
                        set of documents will be required. Minimum one proof is mandatory in
                        each category.
                    </div>
                    <div class="section1">
                        <div class="imageSection-secondform">
                            <div class="heading">Personal Identification:</div>
                            <div class="imageContent">
                                <!-- <img src="assets/images/card.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" class="first" width="200" height="113.333"
                                    viewBox="0 0 200 113.333">
                                    <defs>
                                        <style>
                                            .first cls-1 {
                                                fill: #232f3e;
                                            }
                                        </style>
                                    </defs>
                                    <g id="card" transform="translate(0 -.5)">
                                        <path id="Path_1188"
                                            d="M196.666.5H3.334A3.334 3.334 0 0 0 0 3.834V110.5a3.333 3.333 0 0 0 3.334 3.333h193.332A3.333 3.333 0 0 0 200 110.5V3.834A3.334 3.334 0 0 0 196.666.5zm-3.333 106.667H6.667v-100h186.666zm0 0"
                                            class="cls-1" />
                                        <path id="Path_1189"
                                            d="M54.533 123.168h60a3.335 3.335 0 0 0 3.334-3.334V46.5a3.333 3.333 0 0 0-3.334-3.333h-60A3.333 3.333 0 0 0 51.2 46.5v73.334a3.335 3.335 0 0 0 3.333 3.334zm43.334-6.668H71.2v-13.333a13.334 13.334 0 0 1 26.668 0zM74.533 73.167a10 10 0 1 1 10 10 10 10 0 0 1-10-10zM57.866 49.835H111.2V116.5h-6.667v-13.333A19.981 19.981 0 0 0 94.91 86.1a16.667 16.667 0 1 0-20.753 0 19.981 19.981 0 0 0-9.624 17.064V116.5h-6.667zm0 0"
                                            class="cls-1" transform="translate(-31.2 -26.001)" />
                                        <path id="Path_1190" d="M256 43.168h60v6.667h-60zm0 0" class="cls-1"
                                            transform="translate(-156 -26.001)" />
                                        <path id="Path_1191" d="M256 111.434h76.666v6.666H256zm0 0" class="cls-1"
                                            transform="translate(-156 -67.6)" />
                                        <path id="Path_1192" d="M256 179.7h76.666v6.667H256zm0 0" class="cls-1"
                                            transform="translate(-156 -109.2)" />
                                        <path id="Path_1193" d="M256 230.9h6.667v6.668H256zm0 0" class="cls-1"
                                            transform="translate(-156 -140.399)" />
                                        <path id="Path_1194" d="M298.668 230.9h6.667v6.668h-6.667zm0 0" class="cls-1"
                                            transform="translate(-182.001 -140.399)" />
                                        <path id="Path_1195" d="M341.332 230.9H348v6.668h-6.667zm0 0" class="cls-1"
                                            transform="translate(-207.999 -140.399)" />
                                        <g id="Rectangle_1775" fill="none" stroke="#0096d6" stroke-width="7px"
                                            transform="translate(20 17)">
                                            <rect width="67" height="80" stroke="none" rx="3" />
                                            <rect width="60" height="73" x="3.5" y="3.5" rx=".5" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div>
                                <div class="inputSection">
                                    <div class="optionTag">Do you have Passport ?</div>
                                    <section class="example-section">
                                        <!-- <fieldset class="fieldset" id="group1" required>
                      <span class="wrapSpan"
                        ><input
                          formControlName="is_passport_available"
                          type="radio"
                          value="true"
                          name="is_passport_available"
                        />
                        <span>Yes</span></span
                      >
                      <span class="wrapSpan"
                        ><input
                          formControlName="is_passport_available"
                          type="radio"
                          value="false"
                          name="is_passport_available"
                        />
                        <span>No</span></span
                      >
                    </fieldset> -->
                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_passport_available',
                          'true',
                          $event
                        )
                      " [checked]="
                        secondFormGroup.get('is_passport_available').value ===
                        'true'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_passport_available',
                          'false',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_passport_available').value ===
                        'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label>
                                        </mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">Do you have Aadhar card ?</div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_aadhar_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected('is_aadhar_available', 'true', $event)
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_aadhar_available').value ===
                        'true'
                      ">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected('is_aadhar_available', 'false', $event)
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_aadhar_available').value ===
                        'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">Do you have Voter ID ?</div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_voterid_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected('is_voterid_available', 'true', $event)
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_voterid_available').value ===
                        'true'
                      ">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_voterid_available',
                          'false',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_voterid_available').value ===
                        'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">Do you have Driving License ?</div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_dl_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected('is_dl_available', 'true', $event)
                      " [checked]="
                        secondFormGroup.get('is_dl_available').value === 'true'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected('is_dl_available', 'false', $event)
                      " [checked]="
                        secondFormGroup.get('is_dl_available').value === 'false'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                            </div>
                            <div class="">
                                <p class="error-msg pl-50">
                                    <span *ngIf="
                      secondFormGroup.value.is_passport_available == 'false' &&
                      secondFormGroup.value.is_aadhar_available == 'false' &&
                      secondFormGroup.value.is_voterid_available == 'false' &&
                      secondFormGroup.value.is_dl_available == 'false'
                    ">
                                        Please provide atleast one personal identification proof
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="lineContent"></div>
                    <div class="section2">
                        <div class="imageSection-secondform">
                            <div class="heading">Financial Proof:</div>
                            <div class="imageContent2">
                                <!-- <img src="assets/images/contract.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" class="first" id="contract" width="95.163"
                                    height="118.604" viewBox="0 0 95.163 118.604">
                                    <defs>
                                        <style>
                                            .first cls-1 {
                                                fill: #232f3e;
                                            }
                                        </style>
                                    </defs>
                                    <path id="Path_1196"
                                        d="M62.316 64.633A2.316 2.316 0 1 0 60 62.316a2.317 2.317 0 0 0 2.316 2.317zm0 0"
                                        class="cls-1" transform="translate(-46.101 -46.101)" />
                                    <path id="Path_1197"
                                        d="M62.316 124.633A2.316 2.316 0 1 0 60 122.316a2.317 2.317 0 0 0 2.316 2.317zm0 0"
                                        class="cls-1" transform="translate(-46.101 -92.202)" />
                                    <path id="Path_1198"
                                        d="M6.949 118.6h74.128a6.957 6.957 0 0 0 6.949-6.949V30.114a2.33 2.33 0 0 0-.679-1.638L59.55.679A2.334 2.334 0 0 0 57.912 0H6.949A6.957 6.957 0 0 0 0 6.949v104.706a6.957 6.957 0 0 0 6.949 6.945zM60.229 7.91L80.118 27.8H60.229zm-55.6-.96a2.319 2.319 0 0 1 2.32-2.317H55.6v25.481a2.316 2.316 0 0 0 2.316 2.316h25.478v79.224a2.319 2.319 0 0 1-2.316 2.316H6.949a2.319 2.319 0 0 1-2.316-2.316zm0 0"
                                        class="cls-1" />
                                    <path id="Path_1199"
                                        d="M62.316 190.633h55.6a2.316 2.316 0 1 0 0-4.633h-55.6a2.316 2.316 0 1 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-46.101 -142.913)" />
                                    <path id="Path_1200"
                                        d="M62.316 250.633h55.6a2.316 2.316 0 0 0 0-4.633h-55.6a2.316 2.316 0 0 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-46.101 -189.014)" />
                                    <path id="Path_1201"
                                        d="M102.316 64.633h18.532a2.316 2.316 0 1 0 0-4.633h-18.532a2.316 2.316 0 1 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-76.835 -46.101)" />
                                    <path id="Path_1202"
                                        d="M102.316 124.633h18.532a2.316 2.316 0 1 0 0-4.633h-18.532a2.316 2.316 0 1 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-76.835 -92.202)" />
                                    <path id="Path_1204"
                                        d="M62.316 310.633h32.431a2.316 2.316 0 0 0 0-4.633H62.316a2.316 2.316 0 0 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-46.101 -235.115)" />
                                    <path id="Path_1205"
                                        d="M62.316 370.633h32.431a2.316 2.316 0 0 0 0-4.633H62.316a2.316 2.316 0 0 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-46.101 -281.216)" />
                                    <path id="Path_1206"
                                        d="M62.316 430.633h32.431a2.316 2.316 0 0 0 0-4.633H62.316a2.316 2.316 0 0 0 0 4.633zm0 0"
                                        class="cls-1" transform="translate(-46.101 -327.317)" />
                                    <path id="Path_210" fill="#0096d6"
                                        d="M320 341.861a1.487 1.487 0 0 0 1.487 1.487h8.913a4.713 4.713 0 0 1-4.662 3.4h-4.255a1.531 1.531 0 0 0-1.021 2.628l10.638 10.06a1.483 1.483 0 0 0 2.1-.052 1.534 1.534 0 0 0-.059-2.141l-7.919-7.521h.516a7.891 7.891 0 0 0 7.725-6.373h2.891a1.487 1.487 0 1 0 0-2.974h-2.891a8.272 8.272 0 0 0-1.57-3.4h4.461a1.487 1.487 0 1 0 0-2.974h-14.867a1.487 1.487 0 0 0 0 2.974h4.255a4.975 4.975 0 0 1 4.662 3.4h-8.917a1.487 1.487 0 0 0-1.487 1.486z"
                                        transform="translate(-259.798 -258.849)" />
                                    <path id="Path_213" fill="none"
                                        d="M284.032 333.042A21.035 21.035 0 1 0 263 312.009a21.036 21.036 0 0 0 21.032 21.033zm-4.712-38.47a18.061 18.061 0 1 1-13.346 17.437 18.061 18.061 0 0 1 13.346-17.436z"
                                        transform="translate(-209.907 -222.59)" />
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div>
                                <div class="inputSection">
                                    <div class="optionTag">Do you have PAN card ?</div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_pan_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected('is_pan_available', 'true', $event)
                      " [checked]="
                        secondFormGroup.get('is_pan_available').value === 'true'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected('is_pan_available', 'false', $event)
                      " [checked]="
                        secondFormGroup.get('is_pan_available').value ===
                        'false'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="">
                                    <p class="error-msg pl-50">
                                        <span *ngIf="secondFormGroup.value.is_pan_available == 'false'">
                                            PAN card required
                                        </span>
                                    </p>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">Do you have bank account ?</div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_bank_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected('is_bank_available', 'true', $event)
                      " [checked]="
                        secondFormGroup.get('is_bank_available').value ===
                        'true'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected('is_bank_available', 'false', $event)
                      " [checked]="
                        secondFormGroup.get('is_bank_available').value ===
                        'false'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="">
                                    <p class="error-msg pl-50">
                                        <span *ngIf="secondFormGroup.value.is_bank_available == 'false'">
                                            Bank account required
                                        </span>
                                    </p>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">GST number available ?</div>
                                    <section class="example-section">
                                        <mat-checkbox (change)="
                        checkboxSelected('is_gst_available', 'true', $event)
                      " [checked]="
                        secondFormGroup.get('is_gst_available').value === 'true'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected('is_gst_available', 'false', $event)
                      " [checked]="
                        secondFormGroup.get('is_gst_available').value ===
                        'false'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                        <!-- <mat-radio-group formControlName='is_gst_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->
                                    </section>
                                </div>
                            </div>
                            <!-- <div class="align-middle">
                                <p class="error-msg pl-50">
                                    <span *ngIf="secondFormGroup.value.is_bank_available == 'false' &&
                                    secondFormGroup.value.is_gst_available == 'false' &&
                                    secondFormGroup.value.is_pan_available == 'false'">
                                        Please provide atleast one
                                        financial proof
                                    </span>

                                </p>
                            </div> -->
                        </div>
                    </div>
                    <div class="lineContent"></div>
                    <div class="section2">
                        <div class="imageSection-secondform">
                            <div class="heading">Store Physical Location Proof:</div>
                            <div class="imageContent2">
                                <!-- <img src="assets/images/storeLocation.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" class="location" width="139.693"
                                    height="120.682" viewBox="0 0 139.693 120.682">
                                    <defs>
                                        <style>
                                            .location cls-1 {
                                                fill: #232f3e;
                                            }

                                            .cls-3 {
                                                fill: #0096d6;
                                            }
                                        </style>
                                    </defs>
                                    <g id="Group_1604" transform="translate(-264 -1568.356)">
                                        <g id="Group_1603" transform="translate(60.793 -1514.146)">
                                            <g id="shop" transform="translate(203.207 3082.502)">
                                                <g id="Group_1580">
                                                    <g id="Group_1579">
                                                        <path id="Path_1182"
                                                            d="M119.406 146.073h-2.086V91.682a17.017 17.017 0 0 0 7.838-14.319 1.835 1.835 0 0 0-.242-.91l-14.547-25.459a5.766 5.766 0 0 0-4.995-2.9h-85.59a5.765 5.765 0 0 0-4.995 2.9L.242 76.453a1.835 1.835 0 0 0-.242.91 17.017 17.017 0 0 0 7.838 14.319v54.391H5.752a1.833 1.833 0 0 0 0 3.667h113.654a1.833 1.833 0 0 0 0-3.667zM3.793 79.2h5.878a1.833 1.833 0 1 0 0-3.667H4.993l12.98-22.719a2.09 2.09 0 0 1 1.811-1.051h85.59a2.09 2.09 0 0 1 1.811 1.051l12.98 22.716h-4.679a1.833 1.833 0 1 0 0 3.667h5.879a13.352 13.352 0 0 1-26.451 0h12.735a1.833 1.833 0 1 0 0-3.667H17.51a1.833 1.833 0 1 0 0 3.667h12.734a13.352 13.352 0 0 1-26.451 0zm87.2 0a13.35 13.35 0 0 1-26.448 0zm-30.373 0a13.35 13.35 0 0 1-26.448 0zm43.239 66.877H84.008v-6.131h19.848zm0-9.8H84.008v-33.566h19.848zm9.8 9.8h-6.131v-45.2a1.833 1.833 0 0 0-1.833-1.833h-23.52a1.833 1.833 0 0 0-1.833 1.833v45.2H11.5V93.46a17 17 0 0 0 20.7-8.417 17.016 17.016 0 0 0 30.373 0 17.016 17.016 0 0 0 30.373 0 17 17 0 0 0 20.7 8.418z"
                                                            class="cls-1" transform="translate(0 -48.096)" />
                                                    </g>
                                                </g>
                                                <g id="Group_1582" transform="translate(17.636 50.948)">
                                                    <g id="Group_1581">
                                                        <path id="Path_1183"
                                                            d="M126.886 256.516H73.978a1.833 1.833 0 0 0-1.833 1.833v37.231a1.833 1.833 0 0 0 1.833 1.833h52.908a1.833 1.833 0 0 0 1.833-1.833v-37.231a1.833 1.833 0 0 0-1.833-1.833zm-1.833 37.231H75.812v-33.564h49.241z"
                                                            class="cls-1" transform="translate(-72.145 -256.516)" />
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                        <path id="Path_1209" fill="#f2f9fc"
                                            d="M-1070.323-12059.053s-2.857-10.06 1.136-15.1 11.106-8.021 11.106-8.021 10.122-.929 12.777 1.4 7.705 10.292 7.705 10.292 1.775 9.266 0 12.1-9.2 12.022-9.2 12.022l-6.711 5.97-15.677-14.527z"
                                            transform="translate(1438 13726)" />
                                        <path id="Path_1207"
                                            d="M65.7 247.108a19.459 19.459 0 0 0-27.562 0 20.619 20.619 0 0 0-5.954 13.185 19.5 19.5 0 0 0 1.175 8.03 20.9 20.9 0 0 0 4.482 7.124l12.53 13.353a2.119 2.119 0 0 0 3.089 0l12.534-13.35a20.9 20.9 0 0 0 4.482-7.124 19.507 19.507 0 0 0 1.176-8.03 20.62 20.62 0 0 0-5.952-13.188zm.8 19.762a16.686 16.686 0 0 1-3.59 5.676l-10.988 11.7-10.988-11.7a16.7 16.7 0 0 1-3.591-5.676 15.3 15.3 0 0 1-.928-6.294 16.378 16.378 0 0 1 4.722-10.476 15.221 15.221 0 0 1 21.558 0 16.38 16.38 0 0 1 4.728 10.476 15.3 15.3 0 0 1-.929 6.294z"
                                            class="cls-3" transform="translate(332.001 1399.572)" />
                                        <path id="Path_1208"
                                            d="M70.394 266.714a9.891 9.891 0 1 0 9.686 9.886 9.8 9.8 0 0 0-9.686-9.886zm0 15.543a5.654 5.654 0 1 1 5.449-5.651 5.559 5.559 0 0 1-5.449 5.651z"
                                            class="cls-3" transform="translate(313.523 1383.19)" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div>
                                <div class="inputSection">
                                    <div class="optionTag">
                                        Do you have Owned or rented shop ?
                                    </div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_rented_owned' required>
                                            <mat-radio-button class="example-margin p-r" value='owned'>Owned
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value='rented'>
                                                Rented
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected('is_rented_owned', 'owned', $event)
                      " [checked]="
                        secondFormGroup.get('is_rented_owned').value === 'owned'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Owned</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected('is_rented_owned', 'rented', $event)
                      " [checked]="
                        secondFormGroup.get('is_rented_owned').value ===
                        'rented'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Rented</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">
                                        If Rented, do you have Rent agreement ?
                                    </div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_rented_aggrement_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_rented_aggrement_available',
                          'true',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_rented_aggrement_available')
                          .value === 'true'
                      ">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_rented_aggrement_available',
                          'false',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_rented_aggrement_available')
                          .value === 'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div>
                                    <p class="error-msg pl-50">
                                        <span *ngIf="
                        secondFormGroup.value.is_rented_owned == 'rented' &&
                        secondFormGroup.value.is_rented_aggrement_available ==
                          'false'
                      ">
                                            Rent agreement required
                                        </span>
                                    </p>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag optionTag-tab">
                                        Do you have electricity bill / Gas Connection bill /
                                        Landline Phone bill for latest 3 months ?
                                    </div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_electricy_gas_landline_bill_available' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_electricy_gas_landline_bill_available',
                          'true',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get(
                          'is_electricy_gas_landline_bill_available'
                        ).value === 'true'
                      ">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_electricy_gas_landline_bill_available',
                          'false',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get(
                          'is_electricy_gas_landline_bill_available'
                        ).value === 'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                            </div>
                            <!-- <div class="align-middle">
                                <p class="error-msg pl-50">
                                    <span *ngIf="secondFormGroup.value.is_rented_owned == 'rented' &&
                                    secondFormGroup.value.is_rented_aggrement_available == 'false' &&
                                    secondFormGroup.value.is_electricy_gas_landline_bill_available == 'false'">
                                        Please provide atleast one
                                        store physical location proof
                                    </span>

                                </p>
                            </div> -->
                        </div>
                    </div>
                    <div class="lineContent"></div>
                    <div class="section2 pb-10">
                        <div class="imageSection-secondform">
                            <div class="heading">Business Continuity Proof:</div>
                            <div class="imageContent2">
                                <!-- <img src="assets/images/business.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="89.8" height="139.724"
                                    viewBox="0 0 89.8 139.724">
                                    <defs>
                                        <clipPath id="clip-path">
                                            <path id="Path_1216"
                                                d="M369.444 215.417H290.2c-2.916 0-5.279 18.043-5.279 40.3s2.364 40.3 5.279 40.3h79.241c2.916 0 5.279-18.042 5.279-40.3s-2.364-40.3-5.279-40.3z"
                                                class="cls-1" transform="translate(-195.86 -231.64)" />
                                        </clipPath>
                                        <style>
                                            .cls-1 {
                                                fill: #232f3e;
                                            }
                                        </style>
                                    </defs>
                                    <g id="Group_1616" transform="translate(-266.901 -1962.021)">
                                        <g id="business_2_" transform="translate(177.838 1978.244)">
                                            <path id="Path_1210"
                                                d="M139.4 45.445h24.5a1.419 1.419 0 1 0 0-2.839h-24.5a1.419 1.419 0 0 0 0 2.839z"
                                                class="cls-1" transform="translate(-35.746 -28.71)" />
                                            <path id="Path_1211"
                                                d="M134.736 83.555h25.608a1.419 1.419 0 1 0 0-2.839h-25.608a1.419 1.419 0 0 0 0 2.839z"
                                                class="cls-1" transform="translate(-32.182 -57.804)" />
                                            <path id="Path_1212"
                                                d="M134.736 121.666h57.169a1.419 1.419 0 0 0 0-2.839h-57.169a1.419 1.419 0 0 0 0 2.839z"
                                                class="cls-1" transform="translate(-32.182 -86.9)" />
                                            <path id="Path_1213"
                                                d="M191.906 159.776a1.419 1.419 0 1 0 0-2.839h-57.17a1.419 1.419 0 1 0 0 2.839z"
                                                class="cls-1" transform="translate(-32.182 -115.994)" />
                                            <path id="Path_1215"
                                                d="M141.774 202.395a6.259 6.259 0 0 0 2.665.562 7.134 7.134 0 0 0 3.751-1.043 7.62 7.62 0 0 0 2.055-2.033c.093-.124.206-.274.3-.394a6.445 6.445 0 0 0 1.263.877 8.416 8.416 0 0 0 3.8.969 8.652 8.652 0 0 0 4.534-1.193 1.419 1.419 0 1 0-1.429-2.453 5.8 5.8 0 0 1-3.043.808 5.566 5.566 0 0 1-2.517-.632 3.808 3.808 0 0 1-.834-.6 2.5 2.5 0 0 0-1.69-.769 3.226 3.226 0 0 0-2.657 1.683 5.018 5.018 0 0 1-1.3 1.336 4.224 4.224 0 0 1-3.686.318 2.751 2.751 0 0 1-.891-.7 6.644 6.644 0 0 0 3.053-1.3 7.163 7.163 0 0 0 2.022-2.55 3.6 3.6 0 0 0-.021-3.538 3.812 3.812 0 0 0-2.664-1.566 5.92 5.92 0 0 0-4.46 1.022 5.71 5.71 0 0 0-1.9 4.621l-.026-.011a1.419 1.419 0 1 0-1.119 2.609 10.334 10.334 0 0 0 1.772.579 6.309 6.309 0 0 0 3.02 3.4zm.015-8.971a2.9 2.9 0 0 1 1.707-.491 3.239 3.239 0 0 1 .528.042 1.236 1.236 0 0 1 .743.305c.15.233-.31 1.485-1.367 2.314a4.079 4.079 0 0 1-2.4.8 3.47 3.47 0 0 1 .789-2.97z"
                                                class="cls-1" transform="translate(-34.324 -141.308)" />
                                            <g id="Mask_Group_9" clip-path="url(#clip-path)">
                                                <path id="Path_1214"
                                                    d="M158.114 98.268a3.1 3.1 0 0 0 2.52 1.291 3.142 3.142 0 0 0 1.242-.257l5.389-2.314a3.095 3.095 0 0 0 1.585-4.168l-1.874-3.962-.411-78.424A5.475 5.475 0 0 0 161.062 5h-60.069a5.475 5.475 0 0 0-5.5 5.435v75.006l-3.966 7.525a3.077 3.077 0 0 0 1.234 4.144l5.116 2.858a3.106 3.106 0 0 0 1.52.4 3.154 3.154 0 0 0 .891-.13 3.089 3.089 0 0 0 1.87-1.527l.554-1.045 1.845 1.525-3.24 4.457a4.93 4.93 0 0 0 3.99 7.83 5 5 0 0 0 .859-.074.275.275 0 0 1 0 .028 4.928 4.928 0 0 0 4.869 4.138 5.027 5.027 0 0 0 .862-.075v.03a4.929 4.929 0 0 0 4.869 4.14 5 5 0 0 0 .859-.074v.028a4.952 4.952 0 0 0 8.887 2.1l1.027-1.413 1.921 1.522a5.327 5.327 0 0 0 7.435-.56 5.2 5.2 0 0 0 1.248-2.764 5.313 5.313 0 0 0 5.52-1.59 5.2 5.2 0 0 0 1.247-2.763 5.312 5.312 0 0 0 5.52-1.59 5.206 5.206 0 0 0 1.216-2.579 5.336 5.336 0 0 0 5.944-1.466l.064-.073a5.125 5.125 0 0 0-.537-7.27l-1.169-1a11.257 11.257 0 0 0 2.158-1.905zm8.177-4.039a.262.262 0 0 1-.147.15l-5.389 2.314a.284.284 0 0 1-.367-.131l-.681-1.431a1.424 1.424 0 0 0-.254-.534L147.18 68.8a.244.244 0 0 1-.007-.2c.027-.07.084-.125 5.692-2.313a.282.282 0 0 1 .359.136l13.058 27.607a.245.245 0 0 1 .009.199zm-67.962-83.8a2.633 2.633 0 0 1 2.664-2.6h60.069a2.635 2.635 0 0 1 2.664 2.6l.374 72.361-8.31-17.577a3.129 3.129 0 0 0-3.957-1.566l-5.538 2.162a3.1 3.1 0 0 0-1.678 4.214l.578 1.215-.175.074c-2.114.435-14.685-2.209-16.309-1.7l-5.34 1.674a8.754 8.754 0 0 0-2.924 1.575 11.392 11.392 0 0 0-4.374-.415l.388-.732a3.1 3.1 0 0 0-1.141-4.1l-5.086-3.067a3.124 3.124 0 0 0-4.375 1.212l-7.531 14.295zm1.319 86.947a.269.269 0 0 1-.166.133.284.284 0 0 1-.223-.024l-5.116-2.858a.255.255 0 0 1-.107-.343l14.336-27.2a.269.269 0 0 1 .17-.135.308.308 0 0 1 .08-.011.282.282 0 0 1 .147.042l5.085 3.067a.254.254 0 0 1 .1.338zm4.441 10.87a2.094 2.094 0 0 1-.477-2.935L108.929 98a2.118 2.118 0 0 1 2.937-.477 2.092 2.092 0 0 1 .477 2.933l-1.442 1.983-3.854 5.3-.022.031a2.117 2.117 0 0 1-2.936.481zm5.73 4.093a2.09 2.09 0 0 1-.477-2.93l3.856-5.3a2.118 2.118 0 0 1 2.933-.476 2.094 2.094 0 0 1 .477 2.935l-1.215 1.671-2.613 3.592-.022.031a2.121 2.121 0 0 1-2.94.479zm5.735 4.1a2.094 2.094 0 0 1-.477-2.936l2.652-3.648a2.119 2.119 0 0 1 2.937-.477 2.092 2.092 0 0 1 .476 2.933l-1.76 2.422-.871 1.2-.022.031a2.118 2.118 0 0 1-2.935.475zm8.669 3.614a2.121 2.121 0 0 1-2.939.478 2.091 2.091 0 0 1-.477-2.93l1.456-2a2.119 2.119 0 0 1 2.937-.477 2.092 2.092 0 0 1 .476 2.933zm31.3-13.473l-.064.073a2.49 2.49 0 0 1-3.486.265l-2.07-1.773-.009-.009-5.486-4.7a1.419 1.419 0 1 0-1.845 2.156l.028.024.047.04 5.419 4.64a2.4 2.4 0 0 1 .243 3.4 2.479 2.479 0 0 1-3.471.25l-5.487-4.7A1.419 1.419 0 0 0 137 107.3a1.415 1.415 0 0 0 .5 1.1l3.785 3.24a2.4 2.4 0 0 1 .252 3.4 2.48 2.48 0 0 1-3.472.25l-1.7-1.456-2.082-1.781a1.419 1.419 0 1 0-1.845 2.157l1.81 1.549.271.232a2.4 2.4 0 0 1 .252 3.405 2.479 2.479 0 0 1-3.472.25l-.042-.035-2.418-1.915a4.914 4.914 0 0 0-4.524-5.8 4.915 4.915 0 0 0-4.534-5.743 4.917 4.917 0 0 0-4.344-5.729 4.944 4.944 0 0 0-8.8-4.1l-.4.557-2.167-1.781 10.33-19.483a10.435 10.435 0 0 1 3.993-.314 8.766 8.766 0 0 0-.447.9l-1.632 3.94c-.418 1.01-.8 2.049-1.148 3.087l-1.628 4.926a1.419 1.419 0 0 0 .773 1.744l.351.155a8.5 8.5 0 0 0 8.152-.623 8.235 8.235 0 0 0 3.694-6.089q.012-.123.022-.247c.078-.366.575-2.422 1.94-2.583l2.28.637a5.23 5.23 0 0 1 2.247 1.3l14.565 14.272.071.065 7.651 6.548a2.286 2.286 0 0 1 .241 3.247zm-6.013-11.921L134.977 80.42a8.075 8.075 0 0 0-3.469-2l-2.5-.7a1.362 1.362 0 0 0-.388-.053 4.612 4.612 0 0 0-4.067 2.656 8.26 8.26 0 0 0-.835 2.347 1.388 1.388 0 0 0-.017.14q-.009.131-.022.26c-.164 1.631-5.464 5.118-7.024 4.688l1.2-3.636c.321-.973 25.223-9.492 27.884-10.058a1.411 1.411 0 0 0 .257-.081l.418-.177 10.291 21.622a8.415 8.415 0 0 1-3.015 2.805z"
                                                    class="cls-1" />
                                            </g>
                                        </g>
                                        <path id="Path_1217" fill="#0096d6"
                                            d="M135.624 223.045l-13.515-29a2.36 2.36 0 0 0-3-1.2l-6.516 2.583a2.381 2.381 0 0 0-1.27 3.223l.931 1.986-.438.188a10.977 10.977 0 0 1-5.917-.241l-5.542-1.567a8.454 8.454 0 0 0-4.878.079l-5.349 1.7a8.5 8.5 0 0 0-2.953 1.648 11.666 11.666 0 0 0-4.847-.433l.827-1.581a2.388 2.388 0 0 0-.863-3.134l-5.982-3.662a2.354 2.354 0 0 0-3.321.93l-14.85 28.6a2.373 2.373 0 0 0 .934 3.169l6.028 3.417a2.33 2.33 0 0 0 1.155.308 2.368 2.368 0 0 0 2.1-1.273l.941-1.8 2.256 1.893-3.406 4.755a4.773 4.773 0 0 0-.373 4.934 4.693 4.693 0 0 0 4.96 2.527c.1-.016.193-.04.289-.062.01.1.022.2.038.3a4.707 4.707 0 0 0 5.416 3.925c.1-.016.2-.04.292-.063a4.744 4.744 0 0 0 1.934 3.389 4.688 4.688 0 0 0 3.808.774 4.712 4.712 0 0 0 8.522 2.311l1.17-1.633 2.12 1.7a5.039 5.039 0 0 0 5.245.828 5.09 5.09 0 0 0 3.1-4.339 5.036 5.036 0 0 0 4.486-.514 5.1 5.1 0 0 0 2.293-3.912 5.035 5.035 0 0 0 4.416-.469 5.1 5.1 0 0 0 2.349-3.791 4.981 4.981 0 0 0 2.11.469q.192 0 .385-.014a5.048 5.048 0 0 0 3.471-1.762l.064-.075a5 5 0 0 0-.512-7.022l-1.429-1.241a11.063 11.063 0 0 0 2.59-2.319l.121.257a2.345 2.345 0 0 0 3.06 1.169l6.35-2.767a2.381 2.381 0 0 0 1.2-3.19zm-69.366 4.636l-6.028-3.417 14.848-28.6 5.982 3.662zm7.624 10.112a2.349 2.349 0 0 1-3.291.538 2.381 2.381 0 0 1-.535-3.311l5.338-7.454a2.349 2.349 0 0 1 3.292-.538 2.381 2.381 0 0 1 .535 3.311zm5.742 4.162a2.348 2.348 0 0 1-3.291.538 2.381 2.381 0 0 1-.534-3.311l3.87-5.4a2.348 2.348 0 0 1 3.291-.537 2.381 2.381 0 0 1 .534 3.311l-1.2 1.675zm5.742 4.161a2.349 2.349 0 0 1-3.292.538 2.381 2.381 0 0 1-.534-3.311l2.67-3.728a2.349 2.349 0 0 1 3.292-.537 2.381 2.381 0 0 1 .534 3.311zm7.21 2.112l-1.468 2.05a2.353 2.353 0 0 1-3.292.538 2.385 2.385 0 0 1-.535-3.311l1.468-2.05a2.349 2.349 0 0 1 3.292-.538 2.381 2.381 0 0 1 .535 3.311zm30.487-13.515a2.6 2.6 0 0 1-.622 1.891l-.064.075a2.707 2.707 0 0 1-1.86.947 2.664 2.664 0 0 1-1.962-.653l-6.795-5.9-.783-.68a1.176 1.176 0 0 0-1.665.122 1.193 1.193 0 0 0 .122 1.675l5.5 4.782a2.727 2.727 0 0 1 .272 3.831 2.689 2.689 0 0 1-3.809.273l-5.5-4.775a1.176 1.176 0 0 0-1.665.122 1.193 1.193 0 0 0 .122 1.675l3.79 3.293a2.727 2.727 0 0 1 .278 3.831 2.689 2.689 0 0 1-3.809.28l-3.783-3.302a1.176 1.176 0 0 0-1.665.122 1.193 1.193 0 0 0 .121 1.678l2.084 1.811a2.727 2.727 0 0 1 .278 3.831 2.689 2.689 0 0 1-3.808.28l-.035-.029-2.53-2.034a4.769 4.769 0 0 0-.917-3.974 4.71 4.71 0 0 0-3.643-1.792 4.763 4.763 0 0 0-.874-4.018 4.7 4.7 0 0 0-3.667-1.818 4.764 4.764 0 0 0-.824-3.955 4.706 4.706 0 0 0-3.555-1.88 4.758 4.758 0 0 0-2.351-5.7 4.7 4.7 0 0 0-5.964 1.458l-.548.766-2.517-2.112 10.525-20.158a10.574 10.574 0 0 1 4.52-.222 8.671 8.671 0 0 0-.618 1.2l-1.635 4.006c-.417 1.022-.8 2.071-1.143 3.12l-1.631 5.008a1.19 1.19 0 0 0 .642 1.455l.351.158a8.145 8.145 0 0 0 11.533-6.615q.012-.13.022-.262c.072-.351.618-2.7 2.2-2.846l2.326.66a5.458 5.458 0 0 1 2.353 1.378l14.59 14.51q.028.028.059.055l7.666 6.657a2.59 2.59 0 0 1 .889 1.777zm-2.667-6.461l-4.316-3.748-14.56-14.482a7.823 7.823 0 0 0-3.372-1.975l-2.507-.711a1.482 1.482 0 0 0-.325-.045 4.386 4.386 0 0 0-3.865 2.571 8.177 8.177 0 0 0-.808 2.305 1.168 1.168 0 0 0-.014.117c-.006.091-.014.182-.022.27a5.766 5.766 0 0 1-2.548 4.252 5.884 5.884 0 0 1-5.039.664l1.287-3.953c.324-.994.689-1.99 1.084-2.958l1.63-4a6.167 6.167 0 0 1 3.819-3.5l5.349-1.7a6.106 6.106 0 0 1 3.527-.057l5.542 1.567a13.246 13.246 0 0 0 7.16.253 1.173 1.173 0 0 0 .216-.069l.626-.268 10.468 22.328a8.7 8.7 0 0 1-3.328 3.139zm6.74-1.432l-13.683-29.181 6.516-2.583 13.515 29z"
                                            transform="translate(211.136 1848.107)" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div>
                                <div class="inputSection">
                                    <div class="optionTag optionTag-tab">
                                        Do you have Shop and Establishment certificate ?
                                    </div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='is_shop_establishment_certificate' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_shop_establishment_certificate',
                          'true',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_shop_establishment_certificate')
                          .value === 'true'
                      ">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        checkboxSelected(
                          'is_shop_establishment_certificate',
                          'false',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        secondFormGroup.get('is_shop_establishment_certificate')
                          .value === 'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection" [hidden]="
                    secondFormGroup.value.is_shop_establishment_certificate !=
                    'false'
                  ">
                                    <div class="optionTag">If No, Which document you have ?</div>
                                    <mat-form-field appearance="fill">
                                        <mat-select formControlName="document" placeholder="Select" [required]="
                        secondFormGroup.value
                          .is_shop_establishment_certificate == 'false'
                      ">
                                            <mat-option *ngFor="let document of businessContinuityProof"
                                                [value]="document.id">
                                                {{ document.document }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                        secondFormGroup.get('document').errors &&
                        (secondFormGroup.get('document').dirty ||
                          secondFormGroup.get('document').touched)
                      ">
                                            <mat-hint [hidden]="
                          !secondFormGroup.get('document').errors.required
                        ">
                                                Document is required
                                            </mat-hint>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <!-- <div class="inputSection"
                                    [hidden]="secondFormGroup.value.is_shop_establishment_certificate!='false'">
                                    <div class='optionTag'>Document Number </div>
                                    <mat-form-field co class="example-full-width">
                                        <input matInput formControlName="document_number"
                                            [validateInput]="{'only-numbers': true}"
                                            [required]="secondFormGroup.value.is_shop_establishment_certificate=='false'">

                                        <mat-error
                                            *ngIf="secondFormGroup.get('document_number').errors && (secondFormGroup.get('document_number').dirty || secondFormGroup.get('document_number').touched)">
                                            <mat-hint
                                                [hidden]="!secondFormGroup.get('document_number').errors.required">
                                                Document Number is
                                                required
                                            </mat-hint>
                                        </mat-error>
                                    </mat-form-field>
                                </div> -->
                            </div>

                            <div class="align-middle">
                                <p class="error-msg pl-50">
                                    <!-- <span *ngIf="secondFormGroup.value.is_passport_available == 'false' &&
                                    secondFormGroup.value.is_aadhar_available == 'false' &&
                                    secondFormGroup.value.is_voterid_available == 'false' &&
                                    secondFormGroup.value.is_dl_available == 'false'">
                                        please provide atleast one
                                        personal identification proof
                                    </span> -->
                                    <span *ngIf="!secondFormGroup.valid">
                                        Please fill the required fields
                                    </span>
                                    <span *ngIf="
                      secondFormGroup.valid &&
                      ((secondFormGroup.value.is_passport_available ==
                        'false' &&
                        secondFormGroup.value.is_aadhar_available == 'false' &&
                        secondFormGroup.value.is_voterid_available == 'false' &&
                        secondFormGroup.value.is_dl_available == 'false') ||
                        (secondFormGroup.value.is_bank_available == 'false' &&
                          secondFormGroup.value.is_pan_available == 'false') ||
                        (secondFormGroup.value.is_rented_owned == 'rented' &&
                          secondFormGroup.value.is_rented_aggrement_available ==
                            'false'))
                    ">
                                        Please provide the valid data to continue
                                    </span>
                                </p>
                                <button mat-button matStepperPrevious class="back-button">
                                    &lt;&lt;
                                </button>
                                <button mat-button matStepperNext (click)="Validate()" [disabled]="
                    !secondFormGroup.valid ||
                    (secondFormGroup.value.is_passport_available == 'false' &&
                      secondFormGroup.value.is_aadhar_available == 'false' &&
                      secondFormGroup.value.is_voterid_available == 'false' &&
                      secondFormGroup.value.is_dl_available == 'false') ||
                    secondFormGroup.value.is_bank_available == 'false' ||
                    secondFormGroup.value.is_pan_available == 'false' ||
                    (secondFormGroup.value.is_rented_owned == 'rented' &&
                      secondFormGroup.value.is_rented_aggrement_available ==
                        'false')
                  " class="next-button-2">
                                    Next
                                </button>
                                <button mat-button [disabled]="
                    !secondFormGroup.valid ||
                    (secondFormGroup.value.is_passport_available == 'false' &&
                      secondFormGroup.value.is_aadhar_available == 'false' &&
                      secondFormGroup.value.is_voterid_available == 'false' &&
                      secondFormGroup.value.is_dl_available == 'false') ||
                    secondFormGroup.value.is_bank_available == 'false' ||
                    secondFormGroup.value.is_pan_available == 'false' ||
                    (secondFormGroup.value.is_rented_owned == 'rented' &&
                      secondFormGroup.value.is_rented_aggrement_available ==
                        'false')
                  " matStepperNext class="back-button">
                                    &gt;&gt;
                                </button>
                            </div>
                            <!-- <div class="submitButton">
                                <input type="submit" id="submit" name="Next" value="Next" class="submitPill"><br>
                            </div> -->
                        </div>
                    </div>
                </div>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Hub Delivery Sign Up</ng-template>
            <div class="header-mobile">
                <div class="header3-mob">
                    <div class="line"></div>
                    <div class="circle">3</div>
                </div>
                <p class="align-center">Hub Delivery Sign Up</p>
            </div>
            <form [formGroup]="thirdFormGroup">
                <div class="formContent">
                    <div class="section1">
                        <div class="imageSection">
                            <div class="heading">Hub Delivery Sign Up</div>
                            <div class="signUp">
                                Thank you for expressing your interest in Hub Delivery
                                opportunity
                            </div>
                            <div class="imageContent2 mt-15">
                                <!-- <img src="assets/images/business.svg" /> -->
                                <svg xmlns="http://www.w3.org/2000/svg" class="delivery" width="128.847"
                                    height="121.801" viewBox="0 0 128.847 121.801">
                                    <defs>
                                        <style>
                                            .delivery cls-1 {
                                                fill: #f2f9fc;
                                                stroke: #0096d6;
                                                stroke-width: 3px;
                                            }

                                            .delivery cls-2 {
                                                stroke: none;
                                            }

                                            .delivery cls-3 {
                                                fill: none;
                                            }
                                        </style>
                                    </defs>
                                    <g id="Group_1605" transform="translate(-269 -567.196)">
                                        <g id="delivery-man" transform="translate(269 567.196)">
                                            <path id="Path_1218"
                                                d="M6.838 50.232h21.85a6.848 6.848 0 0 1 6.838 6.842v25.149H43.7a18.773 18.773 0 0 1-.512-5.865c.177-9.578 1.915-17.65 5.166-23.992a25.743 25.743 0 0 1 8-9.641 17.5 17.5 0 0 1-4.686-12.395 16.015 16.015 0 1 1 32.024 0 1.887 1.887 0 0 1-1.892 1.887h-1.278a13.289 13.289 0 0 1 .181 2.175A13.105 13.105 0 0 1 70.174 47.23a31.811 31.811 0 0 1 .939 8.21l4.707 4.05 11.454.926 13.213-4.368c1.211-.4 2.584-.858 3.774 0a3.352 3.352 0 0 1 1.173 2.816v9.823a1.887 1.887 0 0 1-1.887 1.887H101.3l3.446 11.909a1.888 1.888 0 0 1-3.626 1.049l-3.75-12.956H92c6.674 20.352 2.866 33.937-2.987 47.685h3.397l14.131-15.8-2.988-10.323a1.887 1.887 0 0 1 3.626-1.049l2.858 9.874a18.985 18.985 0 0 1 18.763 14.715 1.887 1.887 0 0 1-1.416 2.262l-2.679.617a14.441 14.441 0 0 1-27.909 6.422l-2.114.486a2.464 2.464 0 0 1-1.824-.1 2.167 2.167 0 0 1-1.063-1.448 18.776 18.776 0 0 1-.3-1.879h-39.48a16.083 16.083 0 0 1-31.831 0h-1.791a2.585 2.585 0 0 1-1.96-.711 2.419 2.419 0 0 1-.667-1.835 21.4 21.4 0 0 1 .773-5.113c-1.5-9.127-.057-14.686 2.087-19.036a4.969 4.969 0 0 1-2.255-4.159V86H6.838A6.848 6.848 0 0 1 0 79.156V57.074a6.847 6.847 0 0 1 6.838-6.842zm97.83 78.751a10.586 10.586 0 0 0 8.05 1.357 10.694 10.694 0 0 0 8.268-10.925l-20.473 4.712a10.61 10.61 0 0 0 4.155 4.856zm-9.444-7.516l29.359-6.756a15.2 15.2 0 0 0-15.027-9.958l-14.382 16.082q.018.318.05.632zm-28.509-32.89c.548 1.445.548 3.226.548 5.692v7.122h6.911v-9.77c0-11.047-6.029-13.016-8.735-13.341h-18.5c.074 2.507.64 4.289 1.714 5.421 1.252 1.318 3.394 1.96 6.548 1.963l6.775.007c2.416 0 4.011.978 4.742 2.906zm.548 16.589v4.507h13.459a5.378 5.378 0 0 0-1.3-3.228 4.656 4.656 0 0 0-3.36-1.279zM47.018 74.505h17.165a70.48 70.48 0 0 0 1.809-6.985l-5.219-3.387c-2.849-1.85-4.331-4.464-4.066-7.172a6.673 6.673 0 0 1 4.158-5.461 6.813 6.813 0 0 1 6.335.7 22.285 22.285 0 0 0-.911-4.785 13.3 13.3 0 0 1-2.389-.475 15.636 15.636 0 0 1-4.406-1.746c-3.635 2.172-11.63 9.216-12.476 29.311zm32.76-46.063a12.22 12.22 0 0 0-24.335 1.888c0 5.631 2.7 10.169 7.054 12.166v-9.931a3.755 3.755 0 0 1 3.792-4.114q.085-.008.171-.008zm-2.851 5.95a9.4 9.4 0 0 0-.252-2.175H66.552c-.117.013-.2.026-.262.039a2.245 2.245 0 0 0-.018.309v11.042a9.336 9.336 0 0 0 1.354.1h.013a9.317 9.317 0 0 0 9.289-9.314zm2.447 29.172L74.9 63.2a1.888 1.888 0 0 1-1.079-.45l-8.068-6.939a3.749 3.749 0 0 0-2.421-1.011 2.905 2.905 0 0 0-2.868 2.532c-.125 1.275.715 2.568 2.365 3.639l8.99 5.835h7.555v-3.241zm7.976.645l-4.2-.34V66.8h4.882c.633 0 .787-.526.805-.967a1.5 1.5 0 0 0-1.486-1.623zm4.467-1.3a5.452 5.452 0 0 1 .7 3.88v.016h9.144v-7.168l-9.849 3.256.007.015zm-3.8 7.67H71.261a1.887 1.887 0 0 1-1.028-.3l-.854-.555c-.411 1.816-.879 3.584-1.389 5.254 3.849 1.136 9.959 4.808 9.959 16.649v9.961a7.877 7.877 0 0 1 4.2 2.256 9.206 9.206 0 0 1 2.36 5.836h3.808c3.837-11.057 5.3-22.824-.3-39.1zm-3.107 47.676c.7-1.6 1.37-3.2 2-4.807h-19.6c-2.54 0-3.828-1.156-3.828-3.437V96.157H48.59a1.887 1.887 0 0 1 0-3.775h14.885a8.544 8.544 0 0 0-.289-2.467c-.1-.252-.178-.469-1.214-.469l-6.777-.007c-4.244 0-7.28-1.031-9.282-3.139-.093-.1-.18-.2-.268-.3h-25.5v5.187a1.212 1.212 0 0 0 1.194 1.2H40.13a1.887 1.887 0 0 1 0 3.775H22.449a22.284 22.284 0 0 0-2.749 11.653 20.483 20.483 0 0 1 31.2-2.436 20.793 20.793 0 0 1 5.934 12.883zM36.1 132.026a12.437 12.437 0 0 0 12.08-9.99H24.019a12.438 12.438 0 0 0 12.08 9.99zm-14.225-13.764h31.16a16.93 16.93 0 0 0-16.7-15.194 16.747 16.747 0 0 0-16.061 12l-.021.066a17.421 17.421 0 0 0-.623 3.127zM3.774 79.156a3.069 3.069 0 0 0 3.063 3.067h24.914v-9.747H3.774zm0-10.455h27.977v-4.014H3.774zm0-7.789h27.977v-3.838a3.069 3.069 0 0 0-3.063-3.067H6.838a3.069 3.069 0 0 0-3.063 3.067z"
                                                transform="translate(0 -14)" />
                                        </g>
                                        <g id="Rectangle_1776" class="cls-1" transform="translate(269 603)">
                                            <rect width="36" height="36" class="cls-2" rx="5" />
                                            <rect width="33" height="33" x="1.5" y="1.5" class="cls-3" rx="3.5" />
                                        </g>
                                        <g id="Rectangle_1777" class="cls-1" transform="translate(269 616)">
                                            <rect width="36" height="8" class="cls-2" rx="4" />
                                            <rect width="33" height="5" x="1.5" y="1.5" class="cls-3" rx="2.5" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="contentSection">
                            <div>
                                <div class="inputSection">
                                    <div class="optionTag optionTag-tab">
                                        Do you want to enroll with Hub Delivery as a delivery partner ?
                                    </div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='enroll_ihs_as_delivery_partner' required>
                                            <mat-radio-button class="example-margin" value=true>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value=false>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        thirdFormCheckbox(
                          'enroll_ihs_as_delivery_partner',
                          'true',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        thirdFormGroup.get('enroll_ihs_as_delivery_partner')
                          .value === 'true'
                      ">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        thirdFormCheckbox(
                          'enroll_ihs_as_delivery_partner',
                          'false',
                          $event
                        )
                      " [disableRipple]="true" [checked]="
                        thirdFormGroup.get('enroll_ihs_as_delivery_partner')
                          .value === 'false'
                      ">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="">
                                    <p class="error-msg pl-50">
                                        <span *ngIf="
                        thirdFormGroup.value.enroll_ihs_as_delivery_partner ==
                        'false'
                      ">
                                            Please select YES to continue as Hub Delivery Partner
                                        </span>
                                    </p>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">Interested for :</div>
                                    <!-- <mat-radio-group formControlName='intrested' required>
                                        <mat-radio-button class="example-margin p-r-interested" value='delivery'>
                                            Delivery Only
                                        </mat-radio-button>
                                        <mat-radio-button class="example-margin" value='delivery+pick'>
                                            Delivery + Pick up
                                        </mat-radio-button>
                                    </mat-radio-group> -->
                                    <mat-checkbox (change)="
                      thirdFormCheckbox('intrested', 'delivery', $event)
                    " [checked]="
                      thirdFormGroup.get('intrested').value === 'delivery'
                    " [disableRipple]="true" class="deliveryClass">
                                        <label (click)="$event.preventDefault()">Delivery Only</label></mat-checkbox>

                                    <mat-checkbox (change)="
                      thirdFormCheckbox('intrested', 'delivery+pick', $event)
                    " [checked]="
                      thirdFormGroup.get('intrested').value === 'delivery+pick'
                    " [disableRipple]="true" class="deliveryClass">
                                        <label (click)="$event.preventDefault()">Delivery + Pick
                                            up</label></mat-checkbox>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag optionTag-tab">
                                        How would you like to be contacted by amazon representative?
                                    </div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='contact_source' required>
                                            <mat-radio-button class="example-margin p-r-representive" value='email'>
                                                Email
                                            </mat-radio-button>

                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        thirdFormCheckbox('contact_source', 'email', $event)
                      " [checked]="
                        thirdFormGroup.get('contact_source').value === 'email'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Email</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        thirdFormCheckbox('contact_source', 'phone', $event)
                      " [checked]="
                        thirdFormGroup.get('contact_source').value === 'phone'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Phone</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        thirdFormCheckbox('contact_source', 'both', $event)
                      " [checked]="
                        thirdFormGroup.get('contact_source').value === 'both'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Both</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag">Have you applied earlier also ?</div>
                                    <section class="example-section">
                                        <!-- <mat-radio-group formControlName='applied_earlier' required>
                                            <mat-radio-button class="example-margin" value='true'>Yes
                                            </mat-radio-button>
                                            <mat-radio-button class="example-margin" value='false'>
                                                No
                                            </mat-radio-button>
                                        </mat-radio-group> -->

                                        <mat-checkbox (change)="
                        thirdFormCheckbox('applied_earlier', 'true', $event)
                      " [checked]="
                        thirdFormGroup.get('applied_earlier').value === 'true'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">Yes</label></mat-checkbox>
                                        <mat-checkbox (change)="
                        thirdFormCheckbox('applied_earlier', 'false', $event)
                      " [checked]="
                        thirdFormGroup.get('applied_earlier').value === 'false'
                      " [disableRipple]="true">
                                            <label (click)="$event.preventDefault()">No</label></mat-checkbox>
                                    </section>
                                </div>
                                <div class="inputSection">
                                    <div class="optionTag optionTag-tab">
                                        How did you come to know of this opportunity ?
                                    </div>
                                    <mat-form-field appearance="fill">
                                        <mat-select formControlName="opportinunity_source" placeholder="Select"
                                            (valueChange)="opportunityChange($event)" required>
                                            <mat-option *ngFor="let opertunitySource of opertunity"
                                                value="{{ opertunitySource.name }}">
                                                {{ opertunitySource.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                        thirdFormGroup.get('opportinunity_source').errors &&
                        (thirdFormGroup.get('opportinunity_source').dirty ||
                          thirdFormGroup.get('opportinunity_source').touched)
                      ">
                                            <mat-hint [hidden]="
                          !thirdFormGroup.get('opportinunity_source').errors
                            .required
                        ">
                                                Opportunity Source is required
                                            </mat-hint>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="inputSection" *ngIf="showReferralEmailId">
                                    <label class="lableStyle">Referral code *</label>
                                    <mat-form-field>
                                        <input matInput formControlName="referred_by" required />
                                        <mat-error *ngIf="
                        thirdFormGroup.get('referred_by').errors &&
                        (thirdFormGroup.get('referred_by').dirty ||
                          thirdFormGroup.get('referred_by').touched)
                      ">
                                            <mat-hint [hidden]="
                          !thirdFormGroup.get('referred_by').errors.required
                        ">Email ID is required
                                            </mat-hint>
                                            <mat-hint [hidden]="
                          !thirdFormGroup.get('referred_by').errors.pattern
                        ">Invalid Email ID
                                            </mat-hint>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="inputSection">
                                    <!-- <label class="declaration">
                                        <input type="checkbox" id="declaration" name="declaration" value="declaration"
                                            class="checkboxStyle">
                                        I hereby declare that the information provided in this application is true and
                                        correct. If this information changes, I agree to promptly notify Amazon. I
                                        acknowledge that Amazon may not consider my application or my future
                                        applications in case any information is incorrect.
                                    </label> -->
                                    <section class="example-section acknowledge">
                                        <mat-checkbox class="example-margin" formControlName="information_correct"
                                            [disableRipple]="true">
                                        </mat-checkbox>
                                        <span>
                                            I hereby declare that the information provided in this
                                            application is true and correct. If this information
                                            changes, I agree to promptly notify Amazon. I acknowledge
                                            that Amazon may not consider my application or my future
                                            applications in case any information is incorrect.</span>
                                        <!-- <mat-checkbox class="example-margin" [disabled]="true">Disabled</mat-checkbox> -->
                                    </section>
                                </div>
                                <div class="inputSection align-terms">
                                    <!-- <input type="checkbox" id="vehicle1" formControlName="accept_terms_conditions"
                                        class="checkboxStyle">
                                    <label for="vehicle1" class="declaration"> I accept,<a href="./terms.html"> terms
                                            and conditions</a></label><br> -->
                                    <section class="example-section acknowledge">
                                        <mat-checkbox class="example-margin" formControlName="accept_terms_conditions"
                                            [disableRipple]="true">
                                        </mat-checkbox>
                                        <span>
                                            I accept,&nbsp;
                                            <a (click)="viewPolicy()"> terms and conditions </a>
                                        </span>

                                        <!-- <mat-checkbox class="example-margin" [disabled]="true">Disabled</mat-checkbox> -->
                                    </section>
                                </div>
                            </div>
                            <div class="">
                                <button mat-button matStepperPrevious class="back-button">
                                    &lt;&lt;
                                </button>
                                <!-- <button mat-button (click)="stepper.reset()">Reset</button> -->
                                <button mat-button class="next-button" [disabled]="
                    !thirdFormGroup.valid ||
                    thirdFormGroup.value.enroll_ihs_as_delivery_partner ==
                      'false'
                  " (click)="submit()">
                                    Sign Up
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </mat-step>
    </mat-horizontal-stepper>
</div>
